<template>
  <AdsTextField
    v-model="inputMobile"
    v-bind="$attrs"
    v-on="$listeners"
    @blur="formatContactValue(inputMobile)"
  />
</template>

<script>
import AdsTextField from '../AdsTextField';

export default {
  name: 'AdsFormatContactField',
  components: {AdsTextField},
  computed: {
    inputMobile: {
      get() {
        return this.$attrs.value;
      },
      set(value) {
        this.$listeners.input && this.$listeners.input(value);
      }
    }
  },
  methods: {
    formatContactValue(val) {
      // Restrict to format the numbers, if there is a special character, we won't format it.
      if (val && /^[0-9]+$/.test(val)) {
        // landline number, eg: 13 00 00
        if (val.replace(/\s/g, '').length === 6) {
          this.inputMobile = val.replace(/\W/gi, '').replace(/(.{2})(.{2})/g, '$1 $2 ')
        }

        // landline number, eg: 1234 4321
        if (val.replace(/\s/g, '').length === 8) {
          this.inputMobile = val
            .replace(/\W/gi, '')
            .replace(/(.{4})/g, '$1 ')
            .trim()
        }

        if (val.replace(/\s/g, '').length === 10) {
          // for mobile and Australia-wide landline number. eg: 0400 000 000 || 1300 975 707
          if (
            val.replace(/\W/gi, '').substring(0, 2) === '04'
            || val.replace(/\W/gi, '').substring(0, 2) === '05'
            || val.replace(/\W/gi, '').substring(0, 2) === '13'
            || val.replace(/\W/gi, '').substring(0, 2) === '18'
          ) {
            this.inputMobile = val.replace(/\W/gi, '').replace(/(.{4})(.{3})/g, '$1 $2 ')
          }
          // for landline area code, eg: 02 1234 4321
          if (val.replace(/\W/gi, '').substring(0, 2) === '02' || val.replace(/\W/gi, '').substring(0, 2) === '03' || val.replace(/\W/gi, '').substring(0, 2) === '07' || val.replace(/\W/gi, '').substring(0, 2) === '08') {
            this.inputMobile = val.replace(/\W/gi, '').replace(/(.{2})(.{4})/g, '$1 $2 ')
          }
        }
      }
    },
  }
}
</script>
